<template>
  <div id="pageHead" :class="{'tran_header': tranHead}">
    <span class="header_back" v-show="!noBack" @click="clickBack"> <img class="icon_back" src="../assets/img/icon_zuo.png" alt=""> </span>
    <span class="page_title">
      <slot></slot>
    </span>
    <span class="header_right">
      <slot name="right" class></slot>
    </span>
  </div>
</template>
<script>
export default {
  name: "pageHead",
  data() {
    return {};
  },
  methods: {
    clickBack() {
      this.$router.go(-1);
    }
  },
  props: ["noBack", 'tranHead']
};
</script>
<style lang="scss" scoped>
#pageHead {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 94px;
  line-height: 94px;
  font-size: 36px;
  text-align: center;
  color: #fff;
  z-index: 30;
  // font-weight: bold;
  background: #D72F1D;
  &.tran_header{
    background:transparent;
    color:#fff;
    border-bottom:0;
  }
  .header_back {
    position: absolute;
    top: 0;
    height: 100%;
    left: 30px;
    .icon_back{
      width:40px;
    }
  }
  .page_title {
    font-size: 32px;
  }
  .header_right {
    position: absolute;
    top: 0;
    height: 100%;
    right: 30px;
    background: transparent;
    font-size:28px;
  }
}
</style>
